import React, { useContext } from "react";

// Global state
import { StateContext } from "../../AppStateContext";

//components
import WelcomeMessage from "./WelcomeMessage";

//fade in effect
import FadeIn from "react-fade-in";

const HomePage = () => {
  //global state
  const state = useContext(StateContext);

  return (
    <FadeIn transitionDuration={2000}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          paddingTop: "5px",
          overflowY: "hidden",
          overflowX: "hidden",
          color: state.theme === "dark" ? "##fa0171" : "#00152b",
        }}
      >
        <WelcomeMessage />
      </div>
    </FadeIn>
  );
};

export default HomePage;
